import React from 'react';
import { TrendingUpIcon, ClockIcon, TargetIcon, ZapIcon } from 'lucide-react';
type Stat = {
  icon: React.ReactNode;
  value: string;
  label: string;
};
export function CaseStudySection() {
  const stats: Stat[] = [{
    icon: <TargetIcon className="w-6 h-6" data-id="element-28" />,
    value: '~5',
    label: 'Booked Estimates / Week'
  }, {
    icon: <ClockIcon className="w-6 h-6" data-id="element-29" />,
    value: '4hrs → 10min',
    label: 'Response Time'
  }, {
    icon: <ZapIcon className="w-6 h-6" data-id="element-30" />,
    value: '100%',
    label: 'Online Lead Response Rate'
  }];
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-31">
      <div className="max-w-5xl mx-auto" data-id="element-32">
        <div className="text-center mb-12" data-id="element-33">
          <div className="inline-flex items-center gap-2 bg-viridia-green text-white px-5 py-2.5 rounded-full mb-6 font-bold text-sm" data-id="element-34">
            <TrendingUpIcon className="w-5 h-5" data-id="element-35" />
            Client Results
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-jet-black mb-4" data-id="element-36">
            From 4-Hour Response Times to{' '}
            <span className="text-viridia-green" data-id="element-37">Booked on Autopilot</span>
          </h2>
        </div>

        <div className="bg-gradient-to-br from-jet-black to-gray-900 rounded-2xl shadow-2xl p-8 md:p-12 mb-8 text-white" data-id="element-38">
          <div className="space-y-6 mb-10" data-id="element-39">
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-40">
              A local landscaping company was running Yelp ads but had no system
              to handle the leads coming in. Quote requests sat for hours.
              Follow-up was inconsistent. Hot leads went cold.
            </p>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-41">
              We connected their Yelp ads into a simple CRM with automated
              follow-ups and online booking. Every lead now gets an{' '}
              <span className="text-viridia-green font-bold" data-id="element-42">
                instant response
              </span>{' '}
              instead of waiting hours.
            </p>
            <p className="text-lg md:text-xl text-white font-semibold leading-relaxed" data-id="element-43">
              Response time dropped from about 4 hours to about 10 minutes, with
              a 100% response rate on online leads. Within 5 months, the system
              was consistently generating around{' '}
              <span className="text-viridia-green font-bold" data-id="element-44">
                five booked estimates per week
              </span>{' '}
              on autopilot.
            </p>
          </div>

          <h3 className="text-xl md:text-2xl font-extrabold text-white mb-6 text-center" data-id="element-45">
            From Random Replies to a Predictable{' '}
            <span className="text-viridia-green" data-id="element-46">
              5 Extra Estimates Per Week
            </span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-47">
            {stats.map((stat, index) => <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/10" data-id="element-48">
                <div className="flex justify-center mb-3 text-viridia-green" data-id="element-49">
                  {stat.icon}
                </div>
                <div className="text-3xl md:text-4xl font-extrabold text-viridia-green mb-1" data-id="element-50">
                  {stat.value}
                </div>
                <div className="text-sm font-semibold text-gray-400 uppercase tracking-wide" data-id="element-51">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </div>

        <p className="text-center text-sm text-gray-500 italic" data-id="element-52">
          Results from an anonymous landscaping client. Individual results may
          vary based on market, ad spend, and lead volume.
        </p>
      </div>
    </section>;
}